module.exports = "/assets/b0e9460ec9e53d579e72e0b473021930.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/DV.png
// module id = 1315
// module chunks = 0